export const HTTP_STATUS = {
  400: 400,
  401: 401,
  500: 500,
};

export const PROVIDER = {
  CENTRAL: 'central',
  VDOCIPHER: 'vdocipher',
  ZOOM: 'zoom',
  POWERBATCH: 'powerbatch',
  VIMEO: 'vimeo',
};
